import UtilityService from '../services/utility.service';
import DataService from '../services/data.service';
import { NomenclatureQuizScoresComponent } from './nomenclature-quiz-scores.component';

export class NomenclatureQuizComponent {
    constructor() {
        this.componentName = "nomenclatureQuizComponent";
        this.template = `
            <h3>Nomenclature Quiz Results</h3>
            <h5>Select month for quiz scores</h5>
            <table class="table table-hover">
            <thead>
                <tr>
                <th scope="col">Month</th>
                <th scope="col">Total</th>
                </tr>
            </thead>
            <tbody id="data_row">
                <tr class="table-default">
                <td scope="row">January 2020</td>
                <td>100</td>
                </tr>
            </tbody>
            </table>
        `;

        this.rowTemplate = `
        <tr class="table-default">
          <td scope="row" onClick="_cmp.nomenclatureQuiz.showQuizResults('{Year}{Month}', this.innerHTML)">{MonthYear}</td>
          <td>{Count}</td>
        </tr>
        `;

        this.cache = undefined;
		this.cacheExpiration = undefined;
    }
	
	
	render() {
        _svc.common.renderResults("NomenclatureQuiz", _cmp.nomenclatureQuiz);
    }
    
	postBackSuccess(data) {
        _svc.common.populateDataRows(data, _cmp.nomenclatureQuiz.rowTemplate, _cmp.nomenclatureQuiz.componentName, _cmp.nomenclatureQuiz.template);
		_svc.common.handleCache(_cmp.nomenclatureQuiz);
	}
	
	postBackFailed() {
		_svc.util.clear("#" + _cmp.nomenclatureQuiz.componentName);
	}
	
	showQuizResults(yearMonth, monthYear) {
		_cmp.nomenclatureQuizScores.render(yearMonth, monthYear);
	}
	
	cacheExpired() {
		if (_cmp.nomenclatureQuiz.cacheExpiration == undefined) return true;
		if (_cmp.nomenclatureQuiz.cache == undefined) return true;
		return _cmp.nomenclatureQuiz.cacheExpiration < _svc.util.now();
	}
};

setTimeout(() => {
    _cmp.nomenclatureQuiz = new NomenclatureQuizComponent();
}, 1);